
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-async-data/-embroider-implicit-modules.js";
import "ember-resources/-embroider-implicit-modules.js";
import "@embroider/macros/-embroider-implicit-modules.js";
